import Marquee from "react-fast-marquee";
import { Code2, Sparkles, Workflow, Calendar, Mail, Search, Zap } from "lucide-react";

const TECHNOLOGIES = [
  { icon: Code2, name: "React" },
  { icon: Sparkles, name: "OpenAI" },
  { icon: Workflow, name: "n8n" },
  { icon: Calendar, name: "Calendly" },
  { icon: Mail, name: "Resend" },
  { icon: Search, name: "Google" },
  { icon: Zap, name: "Zapier" },
];

export const TrustedBy = () => (
  <section className="bg-[#050505] text-white py-12 md:py-16 border-t border-white/10" data-testid="tech-stack-section">
    <p className="text-center text-xs uppercase tracking-[0.24em] text-white/40 mb-8 md:mb-10">Technologie, z których korzystamy</p>
    <Marquee speed={40} gradient gradientColor="#050505" gradientWidth={120} autoFill>
      {TECHNOLOGIES.map((b, i) => (
        <div key={i} className="logo-mark flex items-center gap-3 mx-12">
          <b.icon size={26} strokeWidth={1.3} />
          <span className="text-2xl font-semibold tracking-tight">{b.name}</span>
        </div>
      ))}
    </Marquee>
  </section>
);
